import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../models/api-response.model';

/**
 * Bitácora de auditoría (sólo ADMIN). Hoy registra la mano de obra que se cobró en
 * el POS a un precio distinto al del catálogo o al de la OS. Revisar un evento sólo
 * le pone la marca de visto: lo registrado no se edita.
 */
export interface EventoBitacora {
  id: string;
  tipo: 'PRECIO_MANO_OBRA' | string;
  ts: string;
  sucursal_id?: string;
  actor: { id: string; nombre: string };
  venta_id?: string;
  venta_folio?: string;
  orden_id?: string | null;
  orden_folio?: string | null;
  cliente_nombre?: string;
  detalle: {
    nombre: string;
    cantidad: number;
    precio_referencia: number;
    precio_aplicado: number;
    diferencia_total: number;
    origen_referencia: 'OS' | 'CATALOGO';
    cortesia?: boolean;
  };
  revisada: boolean;
  revisada_por?: { id: string; nombre: string };
  revisada_at?: string;
}

@Injectable({ providedIn: 'root' })
export class BitacoraService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/bitacora`;

  pendientes(sucursalId?: string): Observable<EventoBitacora[]> {
    const params: Record<string, string> = { revisada: 'false', dias: '30', limit: '50' };
    if (sucursalId) params['sucursal_id'] = sucursalId;
    return this.http.get<ApiResponse<{ items: EventoBitacora[] }>>(this.apiUrl, { params })
      .pipe(map(res => res.data?.items ?? []));
  }

  revisar(id: string): Observable<EventoBitacora> {
    return this.http.put<ApiResponse<EventoBitacora>>(`${this.apiUrl}/${id}/revisar`, {})
      .pipe(map(res => res.data));
  }
}
